<template>
    <b-modal id="replace-layout-modal" title="Replace Layout"
             @ok="handleOk" :ok-variant="isLoading ? 'secondary' : 'primary'"
             :ok-disabled="isLoading" :cancel-disabled="isLoading">
        <b-alert
            show
            variant="danger"
            fade
            :show="true">
            <p class="mb-0">
                <strong>MAKE SURE!!!</strong>
            </p>
            <ul>
                <li>Replace the correct layout.</li>
                <li>Maintain the same number of pages, with no inserts.</li>
                <li>Keep the original scale (aspect ratio).</li>
            </ul>
            <p class="mb-0">
                <strong>THIS ACTION CANNOT BE UNDONE!!!!!!!</strong> <br/>
                <i>(Just in case: Sync original layout and create a report )</i>
            </p>

        </b-alert>
        <b-form @submit.stop.prevent="handleSubmit">
            <b-form-group label="Select New Layout File" label-for="layout-file">
                <b-form-file
                    id="layout-file"
                    v-model="layoutFile"
                    :state="Boolean(layoutFile)"
                    placeholder="Choose a file..."
                    accept="image/*,.pdf"
                    drop-placeholder="Drop file here..."
                ></b-form-file>
            </b-form-group>
        </b-form>
    </b-modal>
</template>

<script>
import axios from "axios";

export default {
    props: {
        file: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            layoutFile: null,
            isLoading: false
        };
    },
    methods: {
        handleOk(bvModalEvt) {
            bvModalEvt.preventDefault();
            this.handleSubmit();
        },
        handleSubmit() {
            if (!this.layoutFile) {
                this.$bvToast.toast('Please select a file to upload.', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true,
                    position: 'b-toast-bottom-right',
                });
                return;
            }

            const formData = new FormData();
            formData.append('layout_file', this.layoutFile);

            let token = this.$store.state.token;
            this.isLoading = true;

            axios.post(this.$store.getters.apiBase + '/projects/' + this.$route.params.id + '/files/' + this.file.id + '/change-layout', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    "Authorization": "Bearer " + token
                },
            })
                .then(response => {
                    this.$bvToast.toast('Layout was uploaded successfully. It will be generated shortly.', {
                        title: 'Layout uploaded',
                        variant: 'info',
                        solid: true,
                    });
                    this.$bvModal.hide('replace-layout-modal');
                    this.$emit('layout-replaced', response.data);
                    this.isLoading = false;
                })
                .catch(error => {
                    const errorText = error.response.data.message || 'Failed to replace layout.';
                    this.$bvToast.toast(errorText, {
                        title: 'Error',
                        variant: 'danger',
                        solid: true,
                        position: 'b-toast-bottom-right',
                    });
                    this.isLoading = false;
                });
        },
    },
};
</script>
